<template>
  <div class="title__wrapper">
    <div class="el-divider" />
    <span class="notice_title">{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: 'TieleComp',
  data () {
    return {};
  },
  props: {
    title: String
  }
};
</script>

<style lang="less" scoped>
.title__wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 20px;
    .el-divider {
        background-color: #048ef2;
        width: 4px;
        height: 0.6vw;
        margin: 1vh;
    }
    .notice_title {
        font-size: 12px;
    }
}
</style>
